import { render, staticRenderFns } from "./btn-text.vue?vue&type=template&id=78d476e2"
import script from "./btn-text.vue?vue&type=script&lang=js"
export * from "./btn-text.vue?vue&type=script&lang=js"
import style0 from "./btn-text.vue?vue&type=style&index=0&id=78d476e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
